import React, { Component } from 'react';

import { connect } from 'react-redux';

import Lightbox from 'react-images';

import '../styles/QuestionImage.css';

class QuestionImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentImageIndex: 0,
      expanded: false,
    };
  }

  render() {
    const { mainImages, previewImages } = this.props;
    const isMobile = window.innerWidth < 1000;

    return mainImages.length ? (
      <div className="question-image-container">
        {this.state.expanded ?
          <Lightbox
            images={mainImages.map(i => ({ src: i.url }))}
            isOpen={this.state.expanded}
            onClose={() => {
              document.body.style.overflowY = 'scroll';
              document.body.style.paddingRight = '0px';
              this.setState({ expanded: false });
            }}
            currentImage={this.state.currentImageIndex}
            onClickNext={() => this.setState({ currentImageIndex: this.state.currentImageIndex + 1 })}
            onClickPrev={() => this.setState({ currentImageIndex: this.state.currentImageIndex - 1 })}
            backdropClosesModal
          /> : null }
        <div className="image-wrapper">
          <img className="question-image"
            alt="Question"
            src={mainImages[this.state.currentImageIndex].url} />
          { isMobile ? null : <div className="expand-image" onClick={() => this.setState({ expanded: true })}><span>+</span></div> }
        </div>
        {mainImages.length > 0 ?
          <div className="image-prev-row">
            {previewImages.map((image, index) => (
              <div key={image.url} className="image-prev">
                <img onClick={() => this.setState({ currentImageIndex: index })} className={`question-image-preview${this.state.currentImageIndex === index ? ' current-question-prev' : ''}`} alt="preview" src={image.url} />
              </div>
            ))}
          </div> : null}
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];

  return {
    mainImages: question.images.map(i => {
      return ({ url: `https://hippo-med.s3.amazonaws.com/images/inquisition-question/original/${typeof i === 'object' ? i.id.split('.')[0] : i.split('.')[0]}.${i.split('.')[1] || 'jpg'}` })
    }),
    previewImages: question.images.map(i => ({ url: `https://hippo-med.s3.amazonaws.com/images/inquisition-question/original/${typeof i === 'object' ? i.id.split('.')[0] : i.split('.')[0]}.${i.split('.')[1] || 'jpg'}` })),
  };
}

export default connect(mapStateToProps, null)(QuestionImage);



// WEBPACK FOOTER //
// ./src/containers/QuestionImage.js